import React, { Component } from 'react';
import Config from './Config';
import List from './List';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/Settings.css';
import Preferences from './Preferences';
import ShippingService from './ShippingService';
import User from './User';
import Integration from './Integration';

import Tariff from './Tariff';
import Modal from './Modal';
import FX from './functions/functions';
//import OrderEdge from './OrderEdge';

class Admin extends Component {
  constructor(props) {
    super(props);

    /*var setting = this.props.root.state.panelData.account.setting;
    if(setting === 'Preferences'){
      return (
          <div className="Account">
            <Preferences root={this.props.root} />
          </div>
      )
    }
    var dx = <div onClick={this.show.bind(this,'Preferences')}>Preferences</div>;*/
    var settings;
    try{
      settings = JSON.parse(this.props.root.state.user.settings);
      console.log(settings);
    }
    catch(e){
      settings = null;
      console.log(e);
      console.log(settings);
    }
    if(settings == null){
      settings = {date_format: '{d2}/{m2}/{Y} H:i:s'};
    }
    this.state = {option: 'user'};
    this.state.settings = settings;
  }
  componentDidMount(){
    console.log('oooo');
    this.retrieveData(30);
  }
  retrieveData = (limit) => {
    if(isNaN(limit)){
      limit = 30;
      if(parseInt(this.props.root.state.current_customer.products.limit,10)){
        console.log(limit = parseInt(limit,10) + parseInt(this.props.root.state.current_customer.products.limit,10));
      }
    }
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {user_login_id: this.props.root.state.user.id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'settings/' + this.props.root.state.user.id, (res, i) => {
      var currUser = {};
      if (this.props.root.state.current_user){
        currUser = this.props.root.state.current_user;
      }
      currUser.settings = res.user_login.settings;
      console.log(JSON.parse(currUser.settings));
      this.props.root.setState({ current_user : currUser  });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
        //console.log('/' + x[0]);
        //FX.navigate.bind(this,state.panel, undefined ,'/' + x[0],state,true)();
        //window.location = '/' + x[0];
      }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {id: id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      var detail = this.props.root.setState({detail: res.product});
    });
  }
  show = (target) => {
    var panelData = this.props.root.state.panelData;
    panelData.account = {setting : target};
    this.props.root.setState({panelData : panelData});
  }
  handle = (target,e) => {
    var settings = this.state.settings;
    settings[target] = e.target.value;
    this.setState({settings:settings});
  }
  passwordUpdate = () => {
    if(this.state.passwordUpdate){
      console.log('Do a thing');
      if(document.getElementById('current_password').value){
          if(document.getElementById('new_password').value.length > 10){
              if(document.getElementById('new_password').value === document.getElementById('confirm_password').value ){
                FX.load(this.props.root,'updatePassword' , (res, i) => {
                   this.closeModal();
                }, {method:'POST',data:{user_login_id: this.props.root.state.user.id, currentPassword : document.getElementById('current_password').value, newPassword : document.getElementById('new_password').value}});
              }
              else {
                alert('Confirm does not match New Password');
                return false;
              }
          }
          else {
            alert('Please Specify New Password');
            return false;
          }
      }
      else {
          alert('Please specfy Current Password');
          return false;
      }
      this.setState({passwordUpdate:!this.state.passwordUpdate});
    }
    else {
      this.setState({passwordUpdate:!this.state.passwordUpdate});
    }
  }
  closeModal = () => {
      this.setState({passwordUpdate:false});
  }
  setOption = (target) => {
      this.setState({option: target});
  }
  updateUser = () => {
      console.log(this.state.settings)
    FX.load(this.props.root,'user/settings' , (res, i) => {
        console.log(res);
       this.retrieveData();
    }, {method:'POST',data:{user_login_id: this.props.root.state.user.id, settings : this.state.settings}});
  }
  isAdmin = () => {
    var user = this.props.root.state.user;
    return parseInt(user.admin_level, 10);
  }
  render() {
      var shippingService;
      var modal;
      if(this.state.passwordUpdate){
          modal = (
            <Modal title="Update Password" close={this.closeModal}  buttons={[{text:'Cancel',action:this.closeModal},{text:'Update',action:this.passwordUpdate}]}>
                <div className="password_interface">
                   <label>Current Password</label> <input autocomplete="new-password"  id="current_password" type="password" />
                   <label>New Password</label> <input autocomplete="new-password"  id="new_password" type="password" />
                   <label>Confirm Password</label> <input autocomplete="new-password"  id="confirm_password" type="password" />
                </div>
            </Modal>
          )
      }

      var controls;

      if(!this.state.option || this.state.option == 'user'){

             controls = (
                     <div>
                         <div>
                            <label>Date Format:</label>
                 <select className="date_format" onChange={this.handle.bind(this,'date_format')} value={this.state.settings.date_format}>
                    <option value="{d2}/{m2}/{Y} {H}:{i}:{s}">Global (d/m/Y)</option>
                    <option value="{Y}-{m2}-{d2} {H}:{i}:{s}">Scientific (Y-m-d)</option>
                 </select>


                          </div>
                          <div  className="button_carrier">
                            <button className="updatePassword" onClick={this.passwordUpdate}>Update Password</button>
                            <button className="saveSettings" onClick={this.updateUser}>Save Settings</button>
                          </div>
                      </div>)
      }
      else if(this.state.option && this.state.option == 'shipping'){
             controls = <ShippingService root={this.props.root} />
      }
      else if(this.state.option && this.state.option == 'tariffs'){
             controls = <Tariff root={this.props.root} />
      }
      else if(this.state.option && this.state.option == 'client_users'){
             controls = <User root={this.props.root} />
      }
      else if(this.state.option && this.state.option == 'integrations'){
             controls = <Integration root={this.props.root} />
      }

      console.log(this.state);

      if(this.isAdmin()){
                var options = [
                      {mini:false, option: 'user', title: 'User Options'},
                      {mini:false, option: 'client', title: 'Client Options'},
                      {mini:true, option: 'shipping', title: 'Shipping Services'},
                      {mini:true, option: 'client_users', title: 'Users'},
                      {mini:true, option: 'tariffs', title: 'Tariffs'},
                      {mini:true, option: 'integrations', title: 'Integrations'}
                    ]
      }
          else {
                var options = [
                      {mini:false, option: 'user', title: 'User Options'},
                      {mini:false, option: 'client', title: 'Client Options'},
                      {mini:true, option: 'shipping', title: 'Shipping Services'},
                      {mini:true, option: 'client_users', title: 'Users'},
                      //{mini:true, option: 'tariffs', title: 'Tariffs'},
                      //{mini:true, option: 'integrations', title: 'Integrations'}
                    ]

          }


             /* <div className="option" onClick={this.setOption.bind(this,'user')}>
                User Options
              </div>


              <div className="option" onClick={this.setOption.bind(this,'client')}>
                Client Options
              </div>
              <div className="option mini" onClick={this.setOption.bind(this,'shipping')}>
                Shipping Services
              </div>
              <div className="option mini" onClick={this.setOption.bind(this,'client_users')}>
                Users
              </div>
              <div className="option mini" onClick={this.setOption.bind(this,'tariffs')}>
                Tariffs
              </div>
              <div className="option mini" onClick={this.setOption.bind(this,'integrations')}>
                Integrations
              </div>
              <div className="option mini" onClick={this.setOption.bind(this,'password')}>
                Password
              </div>

         */

      options = options.map(opt => {
        var className = 'option';
        if(opt.mini){
          className += ' mini';
        }
        if(opt.option === this.state.option){
          className += ' current';
        }
        return (
            <div className={className} onClick={this.setOption.bind(this,opt.option)}>
              {opt.title}
            </div>
        )
      })


      return (
        <div className="Settings">
          Settings
          <div className="leftBar">
            {options}
          </div>
          <div className="defaults">
             {controls}
          </div>
          {modal}
        </div>
      );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/Admin.js